import { LocalizedText } from "../../../components/LocalizedText";
import * as React from 'react';
import { NpcMenu } from '../../../components/NpcMenu/NpcMenu';
import { Scene } from '../../../enums';
import { useAppSelector } from '../../../hooks';
import { toServer } from '../../../util/ServerSocket';

export const NpcMenuHall: React.FC<{ onEnd: () => void }> = ({ onEnd }) => {
  const currentScene = useAppSelector((state) => state.scene.scene);
  const [talkId, setTalkId] = React.useState('');

  let content = (() => {
    switch (talkId) {
      case '1':
        return (
          <>
            <div className="clickable" onClick={() => toServer('villageSwap', 111, () => setTalkId(''))}><LocalizedText text={"Fire Village"} /></div>
            <div className="clickable" onClick={() => toServer('villageSwap', 211, () => setTalkId(''))}><LocalizedText text={"Water Village"} /></div>
            <div className="clickable" onClick={() => toServer('villageSwap', 311, () => setTalkId(''))}><LocalizedText text={"Lightning Village"} /></div>
            <div className="clickable" onClick={() => toServer('villageSwap', 411, () => setTalkId(''))}><LocalizedText text={"Wind Village"} /></div>
            <div className="clickable" onClick={() => toServer('villageSwap', 511, () => setTalkId(''))}><LocalizedText text={"Earth Village"} /></div>
            <div className="clickable" onClick={() => setTalkId('')}><LocalizedText text={"Back"} /></div>
          </>
        );
      default:
        return (
          <>
            <div key="lounge"><LocalizedText text={"Enter Lounge"} /></div>
            <div key="hall"><LocalizedText text={"Enter Hall"} /></div>
            <div
              className="clickable"
              onClick={() => {
                toServer('checkMissedAchievements');
                onEnd();
              }}><LocalizedText text={"Check Missed Achievements"} /></div>
            {currentScene === Scene.ANGEL_CITY && (
              <div className="clickable" onClick={() => setTalkId('1')}><LocalizedText text={"Change Village"} /></div>
            )}
          </>
        );
    }
  })();

  return (
    <NpcMenu
      onEnd={onEnd}
      npc={currentScene === Scene.ANGEL_CITY ? 16001 : 11001}
      imageOverride={currentScene === Scene.ANGEL_CITY ? 16001 : 10001 + Math.floor(currentScene / 100) * 1000}
      talkId={talkId === '1' ? '__village_swap' : ''}>
      {content}
    </NpcMenu>
  );
};
